import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { Colors } from '@cedro-technologies/people-vue-ui'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: Colors
    }
  }
}

export default new Vuetify(opts)
